export const SOCIAL_URLS = {
  youtube: 'https://www.youtube.com/@GreenVenomV2',
  twitter: 'https://x.com/GreenVenomTV',
};